import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';

export const getDefaultDescriptionText = (fundraiserTypes, fundraiserType) => {
  const fundraiserTypeObj =
    fundraiserTypes &&
    fundraiserTypes.find((type) => {
      return getIn(type, 'name') === remapFundraiserTypeName(fundraiserType);
    });
  return getIn(fundraiserTypeObj, 'defaultDescriptionText');
};

export const remapFundraiserTypeName = (type) => {
  if (type === 'Event') {
    return 'Insamling';
  } else if (type === 'SportEvent') {
    return 'Sportevent';
  } else if (type === 'MemorialFund') {
    return 'Minnesfond';
  } else {
    return type;
  }
};

export const isMemorialFundraiser = (type) => {
  return (
    type === 'MemorialFund' ||
    type === 'Minnesfond' ||
    type === 2 ||
    type === '2'
  );
};

export const isSporteventFundraiser = (type) => {
  return (
    type === 'SportEvent' || type === 'Sportevent' || type === 3 || type === '3'
  );
};

export const getFundraiserTypeId = (type) => {
  if (type === 'Event' || type === remapFundraiserTypeName('Event')) {
    return 1;
  } else if (
    type === 'MemorialFund' ||
    type === remapFundraiserTypeName('MemorialFund')
  ) {
    return 2;
  } else if (
    type === 'SportEvent' ||
    type === 'Cykelmiljonen' ||
    type === remapFundraiserTypeName('SportEvent')
  ) {
    return 3;
  } else {
    return type;
  }
};

export const getSocialMediaBoxText = (translations, fundraiser) => {
  const isMemorial = isMemorialFundraiser(getIn(fundraiser, 'fundraiserType'));

  if (isMemorial) {
    return getIn(translations, 'socialMediaBoxMemorialFund');
  } else {
    const ownerIsUnknown = getIn(fundraiser, 'creator', 'unknown');
    if (!ownerIsUnknown) {
      const name = getIn(fundraiser, 'creator', 'firstName');
      const textBeforeName = getIn(translations, 'socialMediaBoxBeforeName');

      const textAfterName = getIn(translations, 'socialMediaBoxAfterName');

      return `${textBeforeName} ${name} ${textAfterName}`;
    } else {
      return getIn(translations, 'socialMediaBoxTextUnknownOwner');
    }
  }
};
